import { isDevEnv } from './isDevEnv';
import { prefixPath } from './capabilities';

export function getUri() {
  const graphqlPath = '/api/v4/graphql';
  const configPrefixPath = prefixPath === '/' ? '' : prefixPath || '';
  return isDevEnv() ? graphqlPath : configPrefixPath + graphqlPath;
}
